/**
 * How a root collection treats structurally attached records.
 *
 * `baglilari_goster=1` shows everything and `=0` hides the attached records;
 * an absent value means the address expresses no opinion, and the reader falls
 * back to what the person chose last time (see `collectionPreferences`). The
 * parameter is intentionally Turkish: it is part of the existing user-facing
 * URL contract, not an API field, and old `=1` bookmarks keep their meaning.
 */
export type RootPlacementSearch = {
  baglilari_goster?: 0 | 1;
};

export type Placement = "all" | "standalone" | "contextual";

export function placementParam(value: unknown): 0 | 1 | undefined {
  if (value === 1 || value === "1" || value === true) return 1;
  if (value === 0 || value === "0" || value === false) return 0;
  return undefined;
}

export function validateRootPlacementSearch(search: Record<string, unknown>): RootPlacementSearch {
  return { baglilari_goster: placementParam(search.baglilari_goster) };
}

export function placementFromSearch(search: RootPlacementSearch): Placement {
  return search.baglilari_goster === 1 ? "all" : "standalone";
}

export function placementSearchValue(hideContextual: boolean): 0 | 1 {
  return hideContextual ? 0 : 1;
}
